export default __webpack_public_path__ + "static/media/aurora.26578bf1.png";